import { Box, Grid, Typography } from '@material-ui/core'

//import CalistaUiComponentTranslationText from '../CalistaUiComponentTranslationText'
//import FreightBookingTranslationText from 'src/views/freightbooking/shared/FreightBookingTranslationText'
import React from 'react'
import { components } from 'cng-web-lib'

const { CngGridItem } = components

function AccordionHeaderComponent(props) {
  //const translatedTextsObject = CalistaUiComponentTranslationText()
  //const fbTranslatedTextsObject = FreightBookingTranslationText()

  return (
    <Grid container xs={12}>
      <Grid xs={6}>
        <Typography variant='h5' className='font-bolder'>
          {props.title}
        </Typography>
        {!props.hideMandatory ? (
          <Box fontSize={10} paddingBottom={2}>
            <span style={{ color: 'red' }}>*</span>
            'Mandatory'
          </Box>
        ) : null}
      </Grid>
      {props.freightBookingId ? (
        <Grid xs={6} sm={6} container justify='flex-end'>
          <Box fontSize='fontSize' fontWeight='fontWeightBold'>
          </Box>
        </Grid>
      ) : (
        ''
      )}
    </Grid>
  )
}
export default AccordionHeaderComponent
